import React from 'react';
import { useEffect, useState, useRef } from 'react';
import useNotifications from "../hooks/useNotifications";
import { useNavigate, Link } from "react-router-dom";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Loader from "../utils/Loader";
import { exhRegUrl, userManualDownloadUrl, disclaimer } from '../utils/constants';
import NotificationPreviewModal from "./NotificationPreviewModal";
import NotificationDrawer from "./NotificationDrawer";
import StepHeader from '../screens/registration/stepHeader'
import ExhibitorTopMenu from "../common_components/exhibitor_module_topmenu";
import NetworkStatusIndicator from "./NetworkStatusIndicator";
import HeaderInfoTiles, { readSessionList } from "./HeaderInfoTiles";
import MobileInfoPanel, { MobileAccountCard } from "./MobileInfoPanel";




// {head,subHeader}
const AgentHeader = () => {
    const navigate = useNavigate();

    const history = useNavigate();
    const [isLoading, setLoader] = useState(false);
    const [agentCode, setAgentCode] = useState("")
    const marqueeRef = useRef(null);
    const [showProfile, setShowProfile] = useState(false);
    const [showNotifications, setShowNotifications] = useState(false);
    const { notifications, unreadCount, markAllRead, previewItem, openPreview, closePreview, showDrawer, openDrawer, closeDrawer } = useNotifications();
    const notificationRef = useRef(null);

    const loadScripts = () => {
        // This array contains all the files/CDNs 
        // const dynamicScripts = [
        //   'js/jquery.sticky.js',
        //   'js/metisMenu.min.js',
        //   'js/metisMenu-active.js',
        //   'js/main.js',
        //   'js/azia.js'
        // ];

        // for (let i = 0; i < dynamicScripts.length; i++) {
        //   const node = document.createElement('script');
        //   node.src = dynamicScripts[i];
        //   node.type = 'text/javascript';
        //   node.async = false;
        //   document.getElementsByTagName('head')[0].appendChild(node);
        // }
    }

    useEffect(() => {
        loadScripts();
        // console.log("sessionStorage.getItem(sessionExhibitorDrawerData)------->", sessionStorage.getItem(sessionExhibitorDrawerData))
        var agentCode = sessionStorage.getItem('IsAgentDirectLogin') != null && sessionStorage.getItem('IsAgentDirectLogin') == "false" ?
            JSON.parse(sessionStorage.getItem('indirectAgentloginDataSS'))['AgentCode'] != null &&
            JSON.parse(sessionStorage.getItem('indirectAgentloginDataSS'))['AgentCode'] :
            JSON.parse(sessionStorage.getItem('loginDataSS'))['AgentCode'] != null &&
            JSON.parse(sessionStorage.getItem('loginDataSS'))['AgentCode']

        setAgentCode(agentCode)

    }, []);


    const openPdf = () => {
        var URL = userManualDownloadUrl /* http://0.0.0.0:8000/ or http://127.0.0.1:8000/; */
        window.open(URL, null);
    }

    const address = sessionStorage.getItem('ExhibitionAddressSS')

    const [isMobileMenuOpen, setMobileMenuOpen] = useState(false);

    const toggleMobileMenu = () => {
        setMobileMenuOpen(!isMobileMenuOpen);
    };

    const closeMobileMenu = () => {
        setMobileMenuOpen(false);
    };

    const onLogoutClick = () => {
        localStorage.clear();
        sessionStorage.clear();
        navigate("/login");
    };

    const corporateLink = sessionStorage.getItem("sessionExhMailWebsite") || "https://corporate.india-itme.com";

    const profileRef = useRef(null);
    const loginData = JSON.parse(sessionStorage.getItem("loginDataSS") || "{}");

    useEffect(() => {
        function handleClickOutside(event) {
            if (profileRef.current && !profileRef.current.contains(event.target)) {
                setShowProfile(false);
            }
            if (notificationRef.current && !notificationRef.current.contains(event.target)) {
                setShowNotifications(false);
            }
        }

        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);


    return (
        <>
            {isLoading ? (
                <Loader></Loader>
            ) : (
                null
            )}
            <>

                {isMobileMenuOpen && (
                    <div
                        className="mobile-menu-overlay exhibitor-mobile-overlay"
                        onClick={closeMobileMenu}
                    ></div>
                )}


                <div
                    className={`mobile-sidebar-menu exhibitor-mobile-menu ${isMobileMenuOpen ? "mobile-menu-open" : ""
                        }`}
                >
                    <MobileInfoPanel
                        name={sessionStorage.getItem("firstNameSS")}
                        onClose={closeMobileMenu}
                        notifications={notifications}
                        onNotificationClick={(n) => { openPreview(n.id); closeMobileMenu(); }}
                        details={{
                            dates: `${sessionStorage.getItem("ExhibitionFromDateSS") || ''} - ${sessionStorage.getItem("ExhibitionToDateSS") || ''}`,
                            location: address,
                            rows: [{ icon: 'fa-external-link', label: 'Corporate Site', value: <a href={corporateLink} target="_blank" rel="noopener noreferrer" onClick={closeMobileMenu}>Visit the new corporate site</a> }],
                        }}
                        assistance={{ phones: readSessionList('sessionExhibitionMobileNo'), emails: readSessionList('sessionExhibitionEmail') }}
                    >
                        <MobileAccountCard
                            onChangePassword={() => { closeMobileMenu(); navigate('/Change_Password'); }}
                            onSignOut={() => { closeMobileMenu(); onLogoutClick(); }}
                        />
                    </MobileInfoPanel>
                </div>
                {/* app-Header */}
                {/* <div className="app-header header sticky app-heder-with-logo">
                    <div className="container-fluid main-container">
                        <div className="d-flex" style={{ marginTop: '-1rem' }}>
                            <h5 className="exbheader">
                                {" "}
                                {sessionStorage.getItem('ExhibitionFromDateSS')} - {sessionStorage.getItem('ExhibitionToDateSS')} <br />
                                {sessionStorage.getItem('ExhibitionAddressSS')}{" "}<br></br>
                                <span className='mt-1'> For new corporate site please   <a href='https://corporate.india-itme.com' target='blank' className='header-login-a'>click here</a></span>
                            </h5>
                            <div className="right-logo-logo">
                                <img src="images/itme-right-logo.png" style={{ width: 70 }} />
                            </div>
                            <p />
                            <a className="logo-horizontal" href="index.html">
                                <img
                                    src="images/itme-right-logo.png"
                                    className="header-brand-img light-logo1"
                                    alt="logo"
                                    style={{ width: '100%' }}
                                />
                            </a>
                            <div className="d-flex order-lg-2 ms-auto header-right-icons">
                                <button
                                    className="navbar-toggler navresponsive-toggler d-lg-none ms-auto"
                                    type="button"
                                    data-bs-toggle="collapse"
                                    data-bs-target="#navbarSupportedContent-4"
                                    aria-controls="navbarSupportedContent-4"
                                    aria-expanded="false"
                                    aria-label="Toggle navigation"
                                >
                                    <span className="navbar-toggler-icon fe fe-more-vertical" />
                                </button>
                                <div className="navbar navbar-collapse responsive-navbar p-0">
                                    <div
                                        className="collapse navbar-collapse"
                                        id="navbarSupportedContent-4"
                                    >
                                        <div className="d-flex order-lg-2">
                                            <div className="dropdown d-lg-none d-flex">
                                                <a
                                                    href="javascript:void(0)"
                                                    className="nav-link icon"
                                                    data-bs-toggle="dropdown"
                                                >
                                                    <i className="fe fe-search" />
                                                </a>
                                                <div className="dropdown-menu header-search dropdown-menu-start">
                                                    <div className="input-group w-100 p-2">
                                                        <input
                                                            type="text"
                                                            className="form-control"
                                                            placeholder="Search...."
                                                        />
                                                        <div className="input-group-text btn btn-primary">
                                                            <i className="fa fa-search" aria-hidden="true" />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="d-flex country">
                                                <a className="nav-link icon text-center">
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="marquee-text">
                            <marquee
                                behavior="scroll"
                                direction="left"
                                scrollamount="5"
                                ref={marqueeRef}
                                onMouseOver={() => marqueeRef.current?.stop()}
                                onMouseOut={() => marqueeRef.current?.start()}
                            >
                                <b>Disclaimer and Ownership:</b> {disclaimer}
                            </marquee>
                        </div>
                    </div>
                    <div className="user-sle" style={{ marginTop: '-1rem' }}>
                        <div className="user-sle2 mt-1">
                            <i className="fa fa-user-o" aria-hidden="true" />{" "}
                            {
                                sessionStorage.getItem('IsAgentDirectLogin') != null && sessionStorage.getItem('IsAgentDirectLogin') == "false" ?
                                    <span style={{ textTransform: "uppercase" }}>
                                        {JSON.parse(sessionStorage.getItem('indirectAgentloginDataSS'))['FirstName'] != null &&
                                            JSON.parse(sessionStorage.getItem('indirectAgentloginDataSS'))['FirstName']}</span> :
                                    <span style={{ textTransform: "uppercase" }}>
                                        {JSON.parse(sessionStorage.getItem('loginDataSS'))['FirstName'] != null &&
                                            JSON.parse(sessionStorage.getItem('loginDataSS'))['FirstName']}</span>
                            }

                        </div>
                        <div className="mt-1">
                            <a href={`/#/${sessionStorage.getItem("sessionExhibitionCode")}-${agentCode}-Exh`} className='change-pas' target="_blank"><i class="fa fa-share-alt" ></i> Share Link to Exhibitor</a>
                        </div>
                    </div>
                </div> */}

                <div className="app-header header sticky app-heder-with-logo pt-0 visitor-header-light">
                    <div className="container-fluid main-container">
                        <div className="d-flex align-items-center justify-content-between">
                            {/* LOGO */}
                            <div className="side-header d-flex align-items-center">
                                <img
                                    src={sessionStorage.getItem("ExhibitionLogoSS")}
                                    alt="logo"
                                    style={{ width: '45px', margin: '0 auto' }}
                                />
                            </div>

                            {/* EXHIBITION INFO: plain text on tablets */}
                            <h5 className="exbheader text-white d-none d-md-block d-xl-none">
                                {sessionStorage.getItem("ExhibitionFromDateSS")} -{" "}
                                {sessionStorage.getItem("ExhibitionToDateSS")} <br />
                                {sessionStorage.getItem("ExhibitionAddressSS")}
                            </h5>

                            {/* Desktop: shared icon-tile details (header has no top padding, so start 8px down) */}
                            <HeaderInfoTiles
                                fromDate={sessionStorage.getItem("ExhibitionFromDateSS")}
                                toDate={sessionStorage.getItem("ExhibitionToDateSS")}
                                address={sessionStorage.getItem("ExhibitionAddressSS")}
                                mobiles={readSessionList('sessionExhibitionMobileNo')}
                                emails={readSessionList('sessionExhibitionEmail')}
                                style={{ marginTop: 8 }}
                            />

                            {/* NETWORK CONNECTIVITY */}
                            <NetworkStatusIndicator className="ms-auto me-3" />

                            {/* NOTIFICATION BELL */}
                            <div className="notification-bell-wrapper" ref={notificationRef}>
                                <i
                                    className="fa fa-bell fa-2x text-white"
                                    onClick={() => { setShowNotifications(!showNotifications); setShowProfile(false); }}
                                ></i>
                                {unreadCount > 0 && <span className="notification-badge">{unreadCount}</span>}
                                {showNotifications && (
                                    <div className="notification-dropdown shadow">
                                        <div className="notification-dropdown-header">
                                            <span>Notifications</span>
                                            {unreadCount > 0 && <button className="mark-all-read-btn" onClick={markAllRead}>Mark all as read</button>}
                                        </div>
                                        {notifications.length === 0 ? (
                                            <div className="notification-empty"><i className="fa fa-bell-slash-o"></i><br />No notifications</div>
                                        ) : notifications.slice(0, 3).map(n => (
                                            <div key={n.id} className={`notification-item${n.unread ? " unread" : ""}`}>
                                                <span className={`notification-item-icon ${n.type}`}>
                                                    {n.initial}
                                                </span>
                                                <div className="notification-item-content">
                                                    <div className="notification-item-title" dangerouslySetInnerHTML={{ __html: n.title }}></div>
                                                    {n.time && <div className="notification-item-time">{n.time}</div>}
                                                </div>
                                                <span className="notification-eye-btn" title="Preview" onClick={() => openPreview(n.id)}><i className="fa fa-eye"></i></span>
                                            </div>
                                        ))}
                                        <div className="notification-dropdown-footer" style={{ cursor: 'pointer' }} onClick={openDrawer}>View all notifications</div>
                                    </div>
                                )}
                            </div>


                            {/* PROFILE ICON */}
                            <div className="position-relative" ref={profileRef}>
                                <span className="pd-trigger" onClick={() => setShowProfile(!showProfile)}>
                                    <i className="fa fa-user-circle fa-2x text-white"></i>
                                </span>

                                {/* PROFILE DROPDOWN */}
                                {showProfile && (
                                    <div className="profile-dropdown pd-menu">
                                        <div className="pd-head">
                                            <span className="pd-head-icon"><i className="fa fa-user"></i></span>
                                            <strong>{sessionStorage.getItem("firstNameSS")}</strong>
                                        </div>

                                        <a href={corporateLink} target="_blank" rel="noopener noreferrer" className="pd-row pd-link" onClick={() => setShowProfile(false)}>
                                            <span className="pd-icon"><i className="fa fa-external-link"></i></span>
                                            <span>New Corporate Site</span>
                                        </a>
                                        <a href={`/#/${sessionStorage.getItem("sessionExhibitionCode")}-${agentCode}-Exh`} target="_blank" rel="noopener noreferrer" className="pd-row pd-link" onClick={() => setShowProfile(false)}>
                                            <span className="pd-icon"><i className="fa fa-share-alt"></i></span>
                                            <span>Share Link to Exhibitor</span>
                                        </a>

                                        <div className="pd-actions">
                                            <Link to="/Change_Password" className="pd-row pd-link" onClick={() => setShowProfile(false)}>
                                                <span className="pd-icon"><i className="fa fa-cog"></i></span>
                                                <span>Change Password</span>
                                            </Link>
                                            <button type="button" className="pd-row pd-logout" onClick={onLogoutClick}>
                                                <span className="pd-icon"><i className="fa fa-sign-out"></i></span>
                                                <span>Logout</span>
                                            </button>
                                        </div>
                                    </div>
                                )}
                            </div>
                        </div>

                    </div>
                    {/* Absolute Marquee at the bottom of the header */}
                    <div className="marquee-text" style={{ position: 'absolute', bottom: '-4px', left: '0', width: '100%', pointerEvents: 'none', margin: '0' }}>
                        <marquee
                            behavior="scroll"
                            direction="left"
                            scrollamount="5"
                            ref={marqueeRef}
                            onMouseOver={() => marqueeRef.current?.stop()}
                            onMouseOut={() => marqueeRef.current?.start()}
                            style={{ pointerEvents: 'auto', marginBottom: '0', fontSize: "15px", color: "#fff" }}
                        >
                            <b>Disclaimer:</b> {disclaimer}
                        </marquee>
                    </div>

                    <div className="mobile-toggle exhibitor-mobile-toggle d-lg-none">
                        <button
                            onClick={toggleMobileMenu}
                            className="exhibitor-menu-toggle-btn"
                        >
                            <span className="exhibitor-menu-toggle-bar"></span>
                            <span className="exhibitor-menu-toggle-bar"></span>
                            <span className="exhibitor-menu-toggle-bar"></span>
                        </button>
                    </div>

                </div>


                {/* /app-Header */}
            </>
            <NotificationDrawer show={showDrawer} notifications={notifications} unreadCount={unreadCount} markAllRead={markAllRead} openPreview={openPreview} onClose={closeDrawer} />
            <NotificationPreviewModal notification={previewItem} onClose={closePreview} />
        </>
    );
}
export default AgentHeader;

